import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';

@Component({
  selector: 'app-show-moved-modal',
  standalone: true,
  imports: [ModalComponent, TranslatePipe],
  templateUrl: './show-moved-modal.component.html',
  styleUrl: './show-moved-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShowMovedModalComponent extends BaseModalComponent {

  private readonly _location = inject(Location);

  public refreshPage(): void {
    this._location.go(
      '/dashboard'.langUrl()
    );
    window.location.reload();
  }
}
